import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-sidebar',
  styleUrl: 'signet-sidebar.scss',
})
export class SignetSidebar {
  render() {
    return (
      <div class="sidebar">
        <slot></slot>
      </div>
    );
  }
}
